import { HostActionType as e } from "./types/HostActionType.mjs";
import { HostActionFacetKind as t } from "./types/HostActionFacet.mjs";
import { useTrHostActionType as n } from "./useTrHostActionType.mjs";
import { AmountFormat as r, formatCurrency as i } from "@maat/currency";
import { formatStayRange as a, formatTimeAgo as o, formatTimeRemaining as s, nightsBetween as c, toEpochMs as l } from "@maat/datetime";
import { useCallback as u } from "react";
import { useTranslation as d } from "@maat/store-i18n";
//#region src/useHostActionContent.ts
var f = 360 * 60 * 1e3, p = ({ weekdays: p = !0, wholeAmounts: m = !1 } = {}) => {
	let { t: h } = d("actions"), g = n(), _ = u((e) => {
		switch (e.kind) {
			case t.Stay: return [a(e.checkIn, e.checkOut, { weekday: p })];
			case t.StayChange: {
				let t = c(e.previousCheckIn, e.previousCheckOut), n = c(e.checkIn, e.checkOut) - t, r = [h("facet.stayChange", {
					from: a(e.previousCheckIn, e.previousCheckOut, { weekday: p }),
					to: a(e.checkIn, e.checkOut, { weekday: p })
				})];
				return n !== 0 && r.push(n > 0 ? h("facet.nightsDelta", { count: n }) : h("facet.nightsDeltaRemoved", { count: Math.abs(n) })), r;
			}
			case t.Guests: return [h("facet.guests", { count: e.count })];
			case t.Count: return [];
			case t.Text: return [e.text];
			default: return [];
		}
	}, [h, p]);
	return u((t) => {
		let { params: n } = t, a = n?.variant ?? (n?.guest ? void 0 : "unknown"), c = h(a ? [`subject.${t.type}_${a}`, `subject.${t.type}`] : `subject.${t.type}`, {
			...n,
			defaultValue: g(t.type)
		}), u = h(`hint.${t.type}`, {
			...n,
			defaultValue: ""
		}), d = t.expiresAt ? (l(t.expiresAt) ?? 0) - Date.now() : void 0, p = t.expiresAt ? h("urgency.left", { time: s(t.expiresAt) }) : t.createdAt ? h("urgency.waiting", { time: o(t.createdAt) }) : void 0, v = t.type === e.CalendarFeedFailing && n?.count ? [h("facet.failures", { count: n.count })] : [];
		return {
			kicker: g(t.type),
			title: c,
			subtitle: t.object ?? (u || void 0),
			object: t.object,
			urgency: p,
			urgent: d !== void 0 && d < f,
			facets: [...v, ...(t.facets ?? []).flatMap(_)],
			figure: t.figure ? `${t.figure.signed && t.figure.amount > 0 ? "+" : ""}${i(t.figure.amount, t.figure.currency, m ? r.Whole : r.Long)}` : void 0,
			figureCaption: t.figure?.caption && h(`figure.${t.figure.caption}`, { defaultValue: "" }) || void 0
		};
	}, [
		h,
		g,
		_,
		m
	]);
};
//#endregion
export { p as useHostActionContent };
